"use client";

import { Button } from "@/shared/components/ui/button";

export default function AlbumsError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="text-center py-12">
      <p className="text-muted-foreground mb-4">เกิดข้อผิดพลาดในการโหลดอัลบั้ม</p>
      <Button variant="link" size="sm" onClick={reset}>ลองใหม่</Button>
    </div>
  );
}
